module.exports = __webpack_public_path__ + "img/low-activity.055bc6c2.png";